import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import type { ExternaleCaseDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/policyjob/edi/dto/';
import { FLAVOUR_NAME } from '../constants/coverable';

const flavourOrder: string[] = [
    FLAVOUR_NAME.CPR_PROPERTY,
    FLAVOUR_NAME.CVR_PROPERTY,
    FLAVOUR_NAME.CTP_AGRICULTURE_CONTENT,
    FLAVOUR_NAME.CTV_AGRICULTURE_CONTENT,
    FLAVOUR_NAME.PRH_HOUSE,
    FLAVOUR_NAME.PRH_HOLIDAY_HOME,
    FLAVOUR_NAME.PRC_CONTENT,
    FLAVOUR_NAME.PRC_YOUTH_CONTENT,
    FLAVOUR_NAME.LBV_LIABILITY,
    FLAVOUR_NAME.CPR_MACHINERY,
    FLAVOUR_NAME.CVR_MACHINERY,
    FLAVOUR_NAME.TRA_HOUSEHOLD,
    FLAVOUR_NAME.TRA_INDIVIDUAL,
    FLAVOUR_NAME.MVP_CAR,
    FLAVOUR_NAME.UVP_CARAVAN,
    FLAVOUR_NAME.UVP_TRAILER,
    FLAVOUR_NAME.ACC_ACCIDENT,
    FLAVOUR_NAME.ACC_YOUNG,
    FLAVOUR_NAME.ACC_CHILD,
    FLAVOUR_NAME.ACC_CROSS,
    FLAVOUR_NAME.CPR_WORKER_COMP,
    FLAVOUR_NAME.CVR_WORKER_COMP,
    FLAVOUR_NAME.DOG,
    FLAVOUR_NAME.CAT,
    FLAVOUR_NAME.KENNEL,
    FLAVOUR_NAME.STT_SINGLE_TRIP_TRAVEL,
    FLAVOUR_NAME.STC_SINGLE_TRIP_CANCELLATION
];

const sortCoverablesByFlavourName = (a: CoverableDTO, b: CoverableDTO): number => {
    const orderA = a.flavourName ? flavourOrder.indexOf(a.flavourName) : 0;
    const orderB = b.flavourName ? flavourOrder.indexOf(b.flavourName) : 0;
    return orderA - orderB;
};

const sortCoverablesByFlavourNameFieldsAndId = (a: CoverableDTO, b: CoverableDTO): number => {
    const orderA = a.flavourName ? flavourOrder.indexOf(a.flavourName) : 0;
    const orderB = b.flavourName ? flavourOrder.indexOf(b.flavourName) : 0;
    return (
        (orderA - orderB ||
            Object.entries(b).length - Object.entries(a).length ||
            a.fixedId?.localeCompare(b.fixedId ?? '')) ??
        0
    );
};

const findExternalCaseFlavourNameSortedIndex = (caseDto: ExternaleCaseDTO): number => {
    return flavourOrder.findIndex((flavourName) =>
        caseDto.linkedEntityTextWithLabel?.includes(flavourName)
    );
};

const sortExternalCasesByFlavourName = (a: ExternaleCaseDTO, b: ExternaleCaseDTO): number => {
    const orderA = findExternalCaseFlavourNameSortedIndex(a);
    const orderB = findExternalCaseFlavourNameSortedIndex(b);
    return orderA - orderB;
};

export {
    sortCoverablesByFlavourName,
    sortCoverablesByFlavourNameFieldsAndId,
    sortExternalCasesByFlavourName
};
